import React from "react";
import { UIFlightData } from "@flights/types";
import useUpgradeFareInfoController from "./useUpgradeFareInfo.controller";
import Frame from "../../../../../Frame";
import { Text } from "@bookingcom/bui-react";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useUpgradeFareInfoMobile = (flight: UIFlightData) => {
  const { header, subheader, fareInfoContent } = useUpgradeFareInfoController(flight);

  if (!fareInfoContent) return undefined;

  const isCondensed = !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  return {
    header,
    subheader,
    content: isCondensed ? (
      <Frame direction="row" justifyContent="space-between">
        <Frame>
          <Text variant="body_2">{fareInfoContent.content}</Text>
        </Frame>
        <Frame>
          <Text variant="small_1" align="right" wrap="nowrap">
            {fareInfoContent.price}
          </Text>
        </Frame>
      </Frame>
    ) : (
      <div>
        <Text variant="body_2">{fareInfoContent.content}</Text>
        <Text variant="body_2">{fareInfoContent.price}</Text>
        <Text variant="body_2">{fareInfoContent.supportText}</Text>
      </div>
    )
  };
};

export default useUpgradeFareInfoMobile;
